<template>
  <div>
    <main-layout>
      <intent :showDefault="true" @getIntent="getIntent">
        <template slot="header">
          <v-layout wrap>
            <v-flex xs12 sm6>
              <h3 class="headline">{{ $t('Conversation') }}</h3>
            </v-flex>
            <v-flex xs12 sm6 class="text-xs-left text-sm-right">
              <v-btn
                depressed
                color="primary"
                v-if="selectedBot.pagetype != 'enterprise'"
                @click="$router.push({ name: 'Upgrade', hash: '#selectchatbottemplate' })"
              >
                {{ $t('Select a chatbot template') }}
              </v-btn>
              <transfer-intent type="conversation" :intents="intents"></transfer-intent>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 sm8>
              <p style="display: inline-block">
                {{ $t('To let your Chatbot being more accurate, add more conversation') }}
              </p>
            </v-flex>
            <v-flex xs12 sm4 class="text-xs-left text-sm-right px-2 pb-3">
              <a
                target="_blank"
                href="https://blog.zwiz.ai/%E0%B8%81%E0%B8%A3%E0%B8%93%E0%B8%B5%E0%B9%84%E0%B8%AB%E0%B8%99%E0%B8%9A%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%97%E0%B8%B3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9A%E0%B8%AD%E0%B8%97/"
              >
                <strong>*** {{ $t('Why my bot is not answer?') }}</strong>
              </a>
            </v-flex>
          </v-layout>
        </template>
      </intent>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Intent from './Intent'
import TransferIntent from './TransferIntent'
export default {
  components: {
    Intent,
    TransferIntent
  },
  data() {
    return {
      from: '',
      intents: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    dialog() {
      // return this.from == 'Setup'
      return false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from.name
    })
  },
  methods: {
    getIntent(payload) {
      this.intents = payload
    },
    joinGroup() {
      window.open('https://www.facebook.com/groups/zwizaigroup/', '_blank')
      this.from = ''
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.edittingIntent && this.$store.state.edittingIntent.length > 0) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.$store.commit('CLEAR_EDITTING_INTENT')
        next()
      } else {
        next(false)
      }
    } else {
      this.$store.commit('CLEAR_EDITTING_INTENT')
      next()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Conversation.vue